import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeysEnum } from "../types/QueryKeysEnum";
import { patchAccount, PatchAccountRequest } from "../generated-api/account";
import { useAccountClient } from "./useAccountClient";

export const useAccountMutations = () => {
  const client = useAccountClient();
  const queryClient = useQueryClient();

  const patch = useMutation({
    mutationFn: async ({
      accountId,
      patchAccountRequest,
    }: {
      accountId: string;
      patchAccountRequest: PatchAccountRequest;
    }) => {
      const { data } = await patchAccount({
        client,
        throwOnError: true,
        path: { accountId },
        body: patchAccountRequest,
      });

      return data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeysEnum.Account, variables.accountId],
      });
    },
  });

  return { patch };
};
